import React, { useEffect, useContext, useState, useRef,useCallback } from 'react';
import config from "config/config";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab, Box, Tooltip, TextField, Switch, FormControlLabel } from '@mui/material';
import Context from "context/context";
import ReusableTable from "components/table/table";
import Button from '@mui/material/Button';
import Grid from "@mui/material/Grid";
import "./ManagerView.css";
import check from "../../../../assets/images/check.png";
import cross from "../../../../assets/images/remove.png";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Modal from '@mui/material/Modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { styled } from "@mui/material/styles";
import { tooltipClasses } from "@mui/material/Tooltip";
import { Card, CardContent, Typography,CardMedia,IconButton } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { Checkbox } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Addtemplate from "../../../../assets/images/AddTemplate.png";
import savedtemplate from "../../../../assets/images/savedtemplate.jpg";
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';

// import AppraisalCycle from './AppraisalCycle';

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    cursor: "pointer",
    backgroundColor: "#002c5d",
    color: "#ffffff",
  },
});

const EditTemplate = () => {
    const [value, setValue] = useState("1");
  const [showContent, setShowContent] = useState(false);
  const { state, dispatch } = useContext(Context);
  const [kpiData, setKpiData] = useState([]);
  const [kpiKraData, setKpiKraData] = useState([]);
  const [count, setCount] = useState(0);
  const [offset, setOffset] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [selectedKpiIds, setSelectedKpiIds] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const [templates, setTemplates] = useState([]);
  const navigate = useNavigate();
  const [templateData, setTemplateData] = useState(null); 
  const [isTemplateOpen, setIsTemplateOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);


  const limit = 10;

 
  const handleEditTemplate = () => {
    setIsEditing(true); // Set the state to true when the button is clicked
    setIsTemplateOpen(false);
  };
  
    const fetchTemplates = async () => {
      try {
        const response = await fetch(`${config.host}/panel/pms/allTemplates`, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });
        const data = await response.json();
        if (data.status === "Ok") {
          setTemplates(data.data.templatesData);
        } else {
          console.error("Failed to fetch templates");
        }
      } catch (error) {
        console.error("Error fetching templates:", error);
      }
    };

    useEffect(() => {

    fetchTemplates();
  }, []);

  // Navigate to template detail page
  const handleTemplateClick = async (template) => {
    try {
      // Fetch the template details using fetch API
      const url = `${config.host}/panel/pms/updateTemplates?assessmentTemplateId=${template.assessmentTemplateId}`;
      const response = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      // Check if the response is ok
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Error fetching template: ${errorData.message || 'Unknown error'}`);
      }
  
      // Parse the response data
      const data = await response.json();
      if (data.status === "Ok") {
        const fetchedTemplate = data.data.templateData[0];
        setTemplateData(fetchedTemplate);
        setIsTemplateOpen(true);
  
        // After fetching the template data, fetch the related KPIs
        fetchKpiData(); // You can pass search terms here if needed
  
        // Navigate to the template details page
        // navigate(`/template/${template.assessmentTemplateId}`, {
        //   state: { template: fetchedTemplate },
        // });
      } else {
        console.error("Failed to fetch template");
      }
    } catch (error) {
      console.error("Error fetching template details:", error);
    }
  };
  



  const fetchKpiData = useCallback(async (search = "") => {
    try {
      const query = encodeURIComponent(
        JSON.stringify({
          offset: (offset - 1) * limit,
          limit: limit,
          searchValue: search,
        })
      );
      dispatch({ type: "SET_LOADING", payload: true });
      const url = `${config.host}/panel/pms/allActiveKpi?query=${query}`;

      const response = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error response data:", errorData);
        throw new Error(`HTTP error! status: ${response.status}, ${errorData.message || ""}`);
      }

      const data = await response.json();

      if (data.status === "Ok" && Array.isArray(data.data.kpiKraData)) {
        const formattedData = data.data.kpiKraData.map((kpi, index) => [
          index + 1 + (offset - 1) * limit,
          kpi.kraCategory,
          kpi.kpiName,
          kpi.weightage ?? "N/A",
          kpi.role,
        //   kpi.isActive ? (
        //     <img style={{ height: "20px" }} src={check} alt="Active" />
        //   ) : (
        //     <img style={{ height: "20px" }} src={cross} alt="Inactive" />
        //   ),
          <Tooltip title="Select KPI">
            <Checkbox
              checked={selectedKpiIds.includes(kpi.kpiKraId)}
              onChange={() => handleCheckboxChange(kpi.kpiKraId)}
              color="primary"
            />
          </Tooltip>,
        ]);
        setKpiData(formattedData);
        setCount(data.data.count);
        dispatch({ type: "SET_LOADING", payload: false });
      } else {
        console.error("Unexpected data format:", data);
        setKpiData([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
    }
  }, [selectedKpiIds, offset, searchValue]); // add dependencies here

  useEffect(() => {
    fetchKpiData(searchValue);
  }, [fetchKpiData, selectedKpiIds]); // add selectedKpiIds to dependencies

  const handleCheckboxChange = useCallback((kpiId) => {
    setSelectedKpiIds((prevSelectedIds) => {
      const updatedSelectedIds = prevSelectedIds.includes(kpiId)
        ? prevSelectedIds.filter((id) => id !== kpiId)
        : [...prevSelectedIds, kpiId];
      console.log("Updated selected KPI IDs:", updatedSelectedIds); // Debugging log
      return updatedSelectedIds;
    });
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleAddTemplateClick = () => {
    setShowContent(true);
  };

  const handleBackToCard = () => {
    setShowContent(false);
    setTemplateData(null);
  };
  const handleBackFromEdit = () => {
    setIsTemplateOpen(false); // Close template details view
  setTemplateData(null); // Clear the template data
  };

  const handleCreateTemplate = () => {
    setIsModalOpen(true); // Open the modal
  };

  const handleSaveTemplate = async () => {
    try {
      const response = await fetch(`${config.host}/panel/pms/createTemplate`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
            templateName,
            kpiKraIds: selectedKpiIds,
        }),
      });
  
      const data = await response.json();
      if (response.ok && data.status === "Ok") {
        toast.success(data.data.msg || "Template created successfully");
        setIsModalOpen(false);
        setShowContent(false);
        setTemplateName("");
        fetchTemplates();
        setSelectedKpiIds([]);
      } else {
        throw new Error(data.message || "Failed to create template");
      }
    } catch (error) {
      console.error("Error creating template:", error);
      toast.error("Failed to create template");
    }
  };

  const handleCancelTemplate = () => {
    setIsModalOpen(false);
    setTemplateName("");
  };


  const handleDeleteTemplate = async (templateId) => {
    try {
      const response = await fetch(`${config.host}/panel/pms/deleteTemplate?assessmentTemplateId=${templateId}`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }
  
      const result = await response.json();
  
      if (result.status === "Ok" && result.data.deleted === 1) {
        // Remove the deleted template from the templates array
        setTemplates((prevTemplates) =>
          prevTemplates.filter((template) => template.assessmentTemplateId !== templateId)
        );
      } else {
        console.error("Failed to delete template:", result);
      }
    } catch (error) {
      console.error("Error deleting template:", error);
    }
  };

  const formattedTemplateData = (templateData?.kpiKraDetails || []).map((kpi, index) => [
    index + 1, // S.No
    kpi.kraCategory || "N/A", // Assuming kraCategory could be a field in each KPI
    kpi.kpiName,
    kpi.weightage ?? "N/A",
    kpi.role ?? "N/A",
    // kpi.isActive ? (
    //   <img style={{ height: "20px" }} src={check} alt="Active" />
    // ) : (
    //   <img style={{ height: "20px" }} src={cross} alt="Inactive" />
    // ),
    // <Tooltip title="Select KPI">
    //   <Checkbox
    //     checked={selectedKpiIds.includes(kpi.kpiKraDetailsId)}
    //     onChange={() => handleCheckboxChange(kpi.kpiKraDetailsId)}
    //     color="primary"
    //   />
    // </Tooltip>,
  ]);



  








  return (
    <div>
    <h2>Edit Template Content</h2>
    <p>
      This is the content displayed when the "Edit Template" button is clicked.
    </p>
    <Button onClick={() => setIsEditing(false)}>Back</Button>
  </div>
  );
};

export default EditTemplate;